// Helpers de texto compartilhados pelas páginas públicas (landing da escola e
// diretório). Nasceram dentro de SchoolLanding.tsx; foram extraídos quando o
// diretório passou a precisar dos mesmos.

/** Iniciais para o avatar de fallback: "Junco Surf" -> "JS". */
export const initials = (name: string) =>
  name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

export const onlyDigits = (value: string) => value.replace(/\D/g, '')

/**
 * Link de WhatsApp a partir de um telefone brasileiro solto.
 * Números com até 11 dígitos ganham o DDI 55; acima disso assume-se que já veio.
 */
export const whatsappLink = (
  phone: string | null | undefined,
): string | null => {
  const digits = onlyDigits(phone ?? '')
  if (!digits) return null

  return `https://wa.me/${digits.length <= 11 ? `55${digits}` : digits}`
}
